import React from 'react';
import { T } from '../../../../common/locale/translate';

export default class LoggedInNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logged_in: false
    };
  }

  componentWillMount() {
    if (typeof document != 'undefined') {
      let logged_in = document.cookie.match(
        new RegExp('signed_in' + '=([^;]+)')
      );
      if (logged_in != null && logged_in[1] == 1) {
        this.setState({ logged_in: true });
      }
    }
  }

  render = () => (
    <span className="logged-notification">
      {this.state.logged_in ? T('logged_in_msg') : ''}
    </span>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/layout/components/logged_in_notify.jsx